import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const HomeIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.72565 3.67641L4.05898 4.197C3.04788 4.98656 2.54232 5.38135 2.27116 5.93799C2 6.49463 2 7.13766 2 8.42372V9.81845C2 12.3427 2 13.6048 2.78105 14.389C3.40977 15.0202 4.34695 15.1433 6 15.1673V12.5045C6 11.8832 6 11.5725 6.10149 11.3275C6.23682 11.0008 6.49639 10.7413 6.82307 10.6059C7.06813 10.5045 7.37873 10.5045 8 10.5045C8.62127 10.5045 8.93187 10.5045 9.17693 10.6059C9.5036 10.7413 9.7632 11.0008 9.89853 11.3275C10 11.5725 10 11.8832 10 12.5045V15.1673C11.6531 15.1433 12.5902 15.0202 13.2189 14.389C14 13.6048 14 12.3427 14 9.81845V8.42372C14 7.13766 14 6.49463 13.7289 5.93799C13.4577 5.38135 12.9521 4.98656 11.941 4.197L11.2743 3.67641C9.7014 2.44812 8.91493 1.83398 8 1.83398C7.08507 1.83398 6.29858 2.44812 4.72565 3.67641Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
export const HomeIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.08848 4.76364L6.08847 5.54453C4.57182 6.72887 3.81348 7.32105 3.40674 8.15601C3 8.99097 3 9.95552 3 11.8846V13.9767C3 17.763 3 19.6562 4.17157 20.8325C5.11466 21.7793 6.52043 21.964 9 22V18.0057C9 17.0738 9 16.6078 9.15224 16.2403C9.35523 15.7502 9.74458 15.3609 10.2346 15.1579C10.6022 15.0057 11.0681 15.0057 12 15.0057C12.9319 15.0057 13.3978 15.0057 13.7654 15.1579C14.2554 15.3609 14.6448 15.7502 14.8478 16.2403C15 16.6078 15 17.0738 15 18.0057V22C17.4796 21.964 18.8853 21.7793 19.8284 20.8325C21 19.6562 21 17.763 21 13.9767V11.8846C21 9.95552 21 8.99097 20.5933 8.15601C20.1865 7.32105 19.4282 6.72887 17.9115 5.54453L16.9115 4.76364C14.5521 2.92121 13.3724 2 12 2C10.6276 2 9.44787 2.92121 7.08848 4.76364Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
export const HomeIconLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.45131 7.3411L8.11796 8.38229C6.09576 9.96141 5.08464 10.751 4.54232 11.8643C4 12.9775 4 14.2636 4 16.8357V19.6252C4 24.6736 4 27.1979 5.56209 28.7663C6.81955 30.0287 8.69391 30.2749 12 30.3229V24.9972C12 23.7546 12 23.1333 12.203 22.6433C12.4736 21.9898 12.9928 21.4708 13.6461 21.2001C14.1363 20.9972 14.7575 20.9972 16 20.9972C17.2425 20.9972 17.8637 20.9972 18.3539 21.2001C19.0072 21.4708 19.5264 21.9898 19.7971 22.6433C20 23.1333 20 23.7546 20 24.9972V30.3229C23.3061 30.2749 25.1804 30.0287 26.4379 28.7663C28 27.1979 28 24.6736 28 19.6252V16.8357C28 14.2636 28 12.9775 27.4577 11.8643C26.9153 10.751 25.9043 9.96141 23.882 8.38229L22.5487 7.3411C19.4028 4.88453 17.8299 3.65625 16 3.65625C14.1701 3.65625 12.5972 4.88453 9.45131 7.3411Z"
      stroke={color}
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);
